import { useEffect, useState } from "react";
import "../assets/styles/views/check-list.scss";
import { NavLink, useLocation, useOutletContext } from "react-router-dom";
import { get_check_list } from "../utils/endpoints";
import CheckListCard from "../components/CheckListCard";
import BackArrowButton from "../components/BackArrowButton";

export default function CheckList() {
  const [context, setContext] = useOutletContext();
  const [check_list, setCheckList] = useState();
  const [pv_showed, setPvShowed] = useState();
  const [role, setRole] = useState();
  const [backlink, setBackLink] = useState("/");
  const location = useLocation();

  useEffect(() => {
    if (!!location && location?.state) {
      if (location.state?.doc?.pv) setPvShowed(location.state.doc.pv);
      setBackLink(location.state.backlink);
    }
  }, [location]);
  useEffect(() => {
    if (!!context.session && check_list == null && pv_showed) {
      setRole(context.session.profileTypeCode);
      setContext({ loader: true });
      (async () => {
        let response = await context.httpRequest(
          "get",
          get_check_list.replace("*", pv_showed.pv.codicePv),
          null,
          context.session.token
        );
        if (response.result) setCheckList(response.data);
        setContext({ loader: false });
      })();
    }
  }, [context.session, pv_showed, role]);

  const removeCheckList = (id) => {
    let new_list = [...check_list];
    new_list = new_list.filter((x) => x.id != id);
    setCheckList(new_list);
  };

  return (
    <>
      {pv_showed && location?.state?.doc ? (
        <BackArrowButton
          path={backlink}
          state={{
            doc: location.state.doc,
          }}
        />
      ) : (
        <BackArrowButton state={pv_showed} path={backlink} />
      )}

      <section className="check-list w-100 flex-md-wrap px-md-3 d-flex">
        <h1 className="check-list__title px-3 mt-3 mt-md-4 mb-3 text-start text-md-center">
          Lista checklist per punto vendita
        </h1>
        {pv_showed && pv_showed?.pv ? (
          <div className="check-list__recap-container position-sticky p-3 mx-3 mb-3 mx-md-auto border shadow-sm">
            <ul className="mt-2 mb-4 ps-3 d-block">
              <li className="mb-3">
                <span className="fw-bold me-2">DISTRETTO:</span>
                <span>{pv_showed.pv.codiceDistrict}</span>
              </li>
              <li className="mb-3">
                <span className="fw-bold me-2">AREA:</span>
                <span>{pv_showed.pv.codiceArea}</span>
              </li>
              <li className="mb-3">
                <span className="fw-bold me-2">RCR:</span>
                <span>
                  {pv_showed.pv.cognomeRcr} {pv_showed.pv.nomeRcr}
                </span>
              </li>

              <li className="mb-3">
                <span className="fw-bold me-2">PV:</span>
                <span>
                  {`${pv_showed.pv.codicePv} - ${pv_showed.pv.codClasse} - ${
                    pv_showed.pvAttributes.find(
                      (x) => x.name.toUpperCase() === "MODALITA_VENDITA"
                    ).value
                  }`}
                </span>
              </li>
              <li className="mb-3">
                <span className="fw-bold me-2">Indirizzo:</span>
                <span>
                  {`${pv_showed.pv.indirizzo} (${pv_showed.pv.cap}) ${pv_showed.pv.comune} (${pv_showed.pv.prov})`}
                </span>
              </li>
            </ul>
            {pv_showed && role !== "GUEST" ? (
              <NavLink
                to="/check-list-form"
                state={{ pv_info: pv_showed, check_list: null }}
              >
                <button className="q8-blue-button p-3 w-100">
                  CREA NUOVA CHECKLIST
                </button>
              </NavLink>
            ) : null}
          </div>
        ) : null}

        {!check_list || check_list.length === 0 ? (
          <span className="check-list__nothing-found-message d-none d-md-block w-100 text-center mt-4">
            Nessun risultato da mostrare
          </span>
        ) : null}

        <div className="check-list__container-list mb-md-5 d-md-flex flex-md-wrap main-panel w-100 p-3 p-md-0">
          {!check_list || check_list.length === 0 ? (
            <span className="d-block d-md-none w-100 text-center mt-5">
              Nessun risultato da mostrare
            </span>
          ) : (
            check_list
              .sort(
                (a, b) =>
                  new Date(b.lastUpdateDate) - new Date(a.lastUpdateDate)
              )
              .map((item, index) => {
                return (
                  <CheckListCard
                    pv_showed={pv_showed}
                    removeCheckList={removeCheckList}
                    check_list_info={item}
                    context={context}
                    key={index}
                  />
                );
              })
          )}
        </div>
      </section>
    </>
  );
}
